import { __awaiter } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import log from 'pathfinder/utils/log';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import { getDeviceMetadata } from 'pathfinder/utils/sponsoredWidgets/DeviceMetadata';
import SponsoredWidgetsCountdownClockConsumptionModule from './SponsoredWidgetsCountdownClockConsumptionModule';
import { getCountdownClockBaseData } from './helpers/getCountdownClockBaseData';
export const getSponsoredWidgetsCountdownClockConsumptionModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    try {
        const device = getDeviceMetadata();
        const data = yield getCountdownClockBaseData(moduleConfig.config.countdownClocks, (_b = (_a = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.internalState) === null || _a === void 0 ? void 0 : _a.forced) !== null && _b !== void 0 ? _b : false, moduleConfig.config.variant, device);
        return renderClock(moduleConfig, data, new Date(device.dateTime));
    }
    catch (error) {
        log.error('getSponsoredWidgetsCountdownClockConsumptionModuleMethods error', error);
        return false;
    }
});
function renderClock(moduleConfig, data, deviceDate) {
    if (!data) {
        return false;
    }
    const moduleProps = buildModuleProps(moduleConfig, Object.assign(Object.assign({}, data), { deviceDate: deviceDate }));
    const render = () => {
        const reactRoot = document.createElement('div');
        reactRoot.setAttribute('id', 'countdown-clock');
        ReactDOM.render(React.createElement(SponsoredWidgetsCountdownClockConsumptionModule, moduleProps), reactRoot);
        return reactRoot;
    };
    return {
        render,
    };
}
